import Swiper from 'swiper/bundle';
import bus from '../util/eventBus';
import deepAssign from '../util/merge';

const swipers = () => {
  const sliders = document.querySelectorAll('[data-swiper-slider]');

  if (sliders.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < sliders.length; i++) {
      const thumbSlider = sliders[i].querySelector('.swiper-container--thumbs');

      let thumbSwiper = false;

      if (thumbSlider) {
        const thumbDefaults = {
          autoHeight: true,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        };

        const thumbOptions = thumbSlider.getAttribute(
          'data-swiper-thumb-options',
        )
          ? JSON.parse(thumbSlider.getAttribute('data-swiper-thumb-options'))
          : {};

        const thumbSettings = deepAssign(thumbDefaults, thumbOptions);
        thumbSwiper = new Swiper(thumbSlider, thumbSettings);
      }

      const slider = sliders[i].querySelector('.swiper-container--main');
      const navElmNext = slider.getAttribute('data-swiper-navigation-outside')
        ? `.swiper-button-next-${slider.getAttribute(
            'data-swiper-navigation-outside',
          )}`
        : '.swiper-button-next';

      const navElmPrev = slider.getAttribute('data-swiper-navigation-outside')
        ? `.swiper-button-prev-${slider.getAttribute(
            'data-swiper-navigation-outside',
          )}`
        : '.swiper-button-prev';

      if (slider) {
        const defaults = {
          init: false,
          cache: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: navElmNext,
            prevEl: navElmPrev,
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        };

        const options = slider.getAttribute('data-swiper-options')
          ? JSON.parse(slider.getAttribute('data-swiper-options'))
          : {};

        if (options && options.customDotNav === true) {
          defaults.pagination.bulletActiveClass =
            'swiper-pagination-bullet-active';
          defaults.pagination.type = 'custom';
          defaults.pagination.renderCustom = (swiper, current, total) => {
            let out = '';
            // eslint-disable-next-line no-plusplus
            for (let j = 1; j < total + 1; j++) {
              if (j === current) {
                out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=${j} role="button" aria-label="Go to slide ${j}${1}"></span>`;
              } else {
                out += `<span class="swiper-pagination-bullet" tabindex=${j} role="button" aria-label="Go to slide ${j}${1}"></span>`;
              }
            }
            return out;
          };
        } else {
          defaults.pagination.type = '';
        }

        const settings = deepAssign(defaults, options);

        if (thumbSwiper) {
          settings.thumbs = {
            swiper: thumbSwiper,
          };
        }
        const swiper = new Swiper(slider, settings);

        const currentPageWrapper = slider.querySelector(
          '.swiper-fraction--wrapper',
        );
        const currentPageIndex = slider.querySelector(
          '.swiper-fraction [data-current-page]',
        );

        // # trigger lozad redraw
        swiper.on('slideChangeTransitionEnd', () => {
          if (currentPageWrapper && currentPageIndex) {
            currentPageWrapper.style.color = slider.querySelector(
              '.swiper-slide-active',
            ).style.color;
            currentPageIndex.innerText = swiper.realIndex + 1;
          }
        });

        swiper.on('resize', () => {
          if (currentPageWrapper && currentPageIndex) {
            const ActiveSlide = slider.querySelector(
              '.swiper-slide-active [data-fraction-position]',
            );
            if (ActiveSlide) {
              currentPageWrapper.style.left = `${
                ActiveSlide.getBoundingClientRect().left
              }px`;
            }
          }
        });

        swiper.on('init', () => {
          if (currentPageWrapper && currentPageIndex) {
            currentPageWrapper.style.color = slider.querySelector(
              '.swiper-slide-active',
            ).style.color;
            currentPageIndex.innerText = swiper.realIndex + 1;

            const ActiveSlide = slider.querySelector(
              '.swiper-slide-active [data-fraction-position]',
            );
            if (ActiveSlide) {
              currentPageWrapper.style.left = `${
                ActiveSlide.getBoundingClientRect().left
              }px`;
            }
          }
        });

        swiper.init();

        // # trigger lozad redraw
        swiper.on('slideChange', () => {
          bus.emit('arca-slide-change', true);
        });
      }
    }
  }
};

swipers();
